import { getOauthUrl } from "helpers/Auth";
import { useAuth } from "hooks/Auth";
import { useAsyncError } from "hooks/AsyncError";
import React, { useEffect, useState, useRef } from "react";
import { Route, useLocation } from "react-router";
import ChooserShell from "./Shells/ChooserShell";
import LoaderShell from "./Shells/LoaderShell";

function ProtectedRoute({ children, requiresAdmin, ...props }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [hasPublication, setHasPublication] = useState(false);
    const [showPublicationChooser, setShowPublicationChooser] = useState(false);
    const authRef = useRef(false);

    const auth = useAuth();
    const location = useLocation();
    const throwError = useAsyncError();

    useEffect(() => {
        console.log("Validate Publication");
        if (!isAuthenticated) {
            return;
        }
        if (!auth.publication) {
            setShowPublicationChooser(true);
            return;
        }

        setHasPublication(true);

        return () => {
            setShowPublicationChooser(false);
            setHasPublication(false);
            setIsAuthenticated(false);
        };
    }, [isAuthenticated, auth.publication]);

    useEffect(() => {
        // Runs once, on load so it's incumbent on the app to check
        // group and access status
        // using bearer token for related queries
        if (authRef.current === false) {
            authRef.current = true;
            auth.verifyAuth()
                .then((didAuthenticate) => {
                    console.info("Validate protected route");
                    if (didAuthenticate === -1) {
                        throwError(
                            new Error(
                                "SNworks accounts server is not responding."
                            )
                        );
                        return;
                    }
                    if (!didAuthenticate) {
                        window.location.href = getOauthUrl(location.pathname);
                        return;
                    }
                    setIsAuthenticated(true);
                })
                .catch((err) => {
                    throwError(
                        new Error("The CEO server is not responding.", {
                            cause: err,
                        })
                    );
                    return;
                });
        }
        return () => {
            setIsAuthenticated(false);
            authRef.current = false;
        };
        // TODO not sure how to memoize this without causing auth issues or re-rendering
        // eslint-disable-next-line
    }, []);

    if (isAuthenticated && showPublicationChooser) {
        return <ChooserShell />;
    }

    return (
        <Route
            {...props}
            render={() =>
                isAuthenticated && hasPublication ? (
                    children
                ) : (
                    <LoaderShell statusMessage="Checking access..." />
                )
            }
        />
    );
}

export default ProtectedRoute;
